export default "__VITE_ASSET__DxAt1PA9__"